export const isToday = (date: Date, now: number): boolean => {
  const today = new Date(now);

  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
};
